// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { ActionTypes } from "../actions/actionTypes";
import { AnyAction } from "../actions/actionCreators";
import { IAsset } from "../../models/applicationState";

/**
 * App Title Reducer
 * Actions handled:
 *  SET_TITLE
 * @param {string} state
 * @param {AnyAction} action
 * @returns {any}
 */
export const reducer = (state: IAsset[] = [], action: AnyAction) => {

    let newState: IAsset[] = [];

    switch (action.type) {
        case ActionTypes.LOAD_TEST_ALL_FILES:
            return  [
                { ...action.payload },
                ...state.filter((file) => file.id !== action.payload.id),
            ];
        case ActionTypes.UPDATE_ASSET_STATE_WITH_IMAGE_URI_SUCCESS:
                newState = state.map((asset) => {
                const updatedAsset = { ...asset };
                if (asset.id === action.payload.asset.id) {
                    updatedAsset.pdfBlob = action.payload.imageUri;
                }
                return updatedAsset;
            });
                return newState;
        case ActionTypes.DELETE_ASSET_SUCCESS:
            return [...state.filter((file) => file.id !== action.payload.id)];
        case ActionTypes.LOGGED_OUT_USER:
                return [];
        case ActionTypes.CLEAR_EXISTING_TEST_FILES_SUCCESS:
            return [];
        default:
            return state;
    }
};
